import {
  BASIC_KEY_BBXB,
  INPUT_TYPES
} from '@/pages/Survey/utils'

const BASIC_QS = {}

/**
 * @param key
 * @param type
 * @param options
 */
function createBq (key, type, options) {
  const bq = {
    code: Math.ceil(Math.random() * 10000),
    title: key.trim(),
    pCode: null, // 上级题目编号
    level: 1,
    showType: 1,
    sort: 1
  }

  bq.bqBasic = true // 基础题目标志
  bq.subType = type
  bq.question = options

  return (BASIC_QS[key.trim()] = bq)
}

function normalizeOptions (pairs) {
  return pairs.map(([subCode, subTitle, remains]) => {
    return {
      subCode,
      subTitle,
      ...(remains || {})
    }
  })
}

// install BQ
const allQuestions = [
  createBq(BASIC_KEY_BBXB, INPUT_TYPES.SINGLE_OPTION, normalizeOptions([
    ['101-code', '男'],
    ['102-code', '女']
  ])),
  createBq(BASIC_KEY_BBXB, INPUT_TYPES.SINGLE_OPTION, normalizeOptions([
    ['101-code', '男'],
    ['102-code', '女']
  ]))
]

const baseQuestion = allQuestions

export default {
  data: {
    baseQuestion
  }
}
